<template>
  <div class="entreprise-container">
    <EntrepriseNavBar :entreprise-id="entrepriseId" />
    <div class="entreprise-content">
      <slot />
    </div>
  </div>
</template>

<script>
import EntrepriseNavBar from "./EntrepriseNavBar.vue";

export default {
  name: "EntrepriseContentWrapper",
  components: {
    EntrepriseNavBar,
  },
  props: {
    entrepriseId: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>

<style scoped>
.entreprise-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.entreprise-content {
  width: 100%;
}
</style>
